import { render } from "./TermsAndConditions.vue?vue&type=template&id=6c1a33d8"
import script from "./TermsAndConditions.vue?vue&type=script&lang=js"
export * from "./TermsAndConditions.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/TermsAndConditions.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6c1a33d8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6c1a33d8', __exports__)) {
    console.log('reload')
    api.reload('6c1a33d8', __exports__)
  }
  
  module.hot.accept("./TermsAndConditions.vue?vue&type=template&id=6c1a33d8", () => {
    console.log('re-render')
    api.rerender('6c1a33d8', render)
  })

}


export default __exports__